<ion-header>
  <ion-toolbar>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      {{ 'STRIPE.title.result' | translate }}
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">

</ion-content>
